"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_TITLE_LINE_HEIGHT = exports.MENU_TITLE_FONT_SIZE = exports.MENU_LINE_HEIGHT = exports.MENU_FONT_SIZE = void 0;
exports.MENU_FONT_SIZE = 14;
exports.MENU_LINE_HEIGHT = 1.5;
exports.MENU_TITLE_FONT_SIZE = 11;
exports.MENU_TITLE_LINE_HEIGHT = 1.36;
//# sourceMappingURL=constants.js.map